import { supabase } from '@/integrations/supabase/client';

export interface ScrapedProduct {
  name: string;
  price: number;
  unitPrice?: number;
  size?: string;
  brand?: string;
  image?: string;
  url?: string;
  store: string;
  category?: string;
}

export interface ScrapeResponse {
  success: boolean;
  data?: ScrapedProduct[];
  query?: string;
  error?: string;
}

export async function scrapeGroceryPrices(
  query: string,
  stores?: string[]
): Promise<ScrapeResponse> {
  const { data, error } = await supabase.functions.invoke('scrape-prices', {
    body: { query, stores },
  });

  if (error) {
    return { success: false, error: error.message };
  }

  return data as ScrapeResponse;
}
